import { Component, OnInit } from '@angular/core';

import { GroupService } from '../../services/group.service';
import { NaviService } from '../../services/navi.service';
import { Study } from '../../models/study';
import { BasicError, Error403, Error409 } from '../../models/error/error';
declare var $: any;

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.css']
})
export class GroupComponent implements OnInit {
  public myObj: Study[] = [];
  public myArr: Study[] = [];
  public tmpMyArr = null;
  public tmpMyObj = null;
  public amountStudies;
  public canSubscribe = true;

  public lastUpdateCount = 0;
  public timeout = null;


  // Vars for Modal Window
  public isInvite = false;
  public isPassword = false;
  public isWrongPassword = false;
  public isUndefined = false;
  public isSubscribed = false;
  public isPending = false;
  public showQuestionToSub = true;
  public studyTitle: String;
  public studyId: String;
  public studyAccessType: String;
  public studyPassword: String;

  // Vars for unsubscribe from Group
  public isUnsubscribed = false;

  // Vars for Navigation
  public groupdetailspatientUrl: String;


  constructor(private allGroups: GroupService, private naviService: NaviService) {
    this.getGroups();
  }

  ngOnInit() {
  }

  /**
   * This function checks if the current studyId is in the list of
   * myStudies
   * @param id id of current study to check
   */
  public isInList(id) {
    let ret = false;

    for (let i = 0; i < this.myArr.length; i++) {
      if (this.myArr[i].getId() === id) {
        ret = true;
        break;
      }
    }

    return ret;
  }

  /**
   * This function updates the dataTable rows (necessary to work)
   */
  public updateRows() {
    if (this.lastUpdateCount !== this.myObj.length) {
      this.lastUpdateCount = this.myObj.length;

      if (this.timeout !== null) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(function () {
        $('#datatable-responsive').DataTable({
          'destroy': true,
          'pageLength': 25
        });
      }, 200);
    }
  }

  public subscribeToGroupFromAllGroup(studyid: String, atype: String, stTitle: String) {
    this.initModalWindow();
    if (atype === 'password') {
      this.isPassword = true;
    } else {
      this.isUndefined = true;
    }

    this.studyTitle = stTitle;
    this.studyId = studyid;
    this.studyAccessType = atype;
  }


  public subscribeFinallyToGroup() {
    if (this.studyAccessType === 'password') {
      this.allGroups.subscribeToGroup(this.studyId, this.studyAccessType, this.studyPassword).subscribe(data => {
        if (data instanceof BasicError) {
          if (data instanceof Error403) {
            console.log('WRONG PASSWORD');
            this.isWrongPassword = true;
          }
          this.isSubscribed = false;
          return;
        }
        this.isPassword = false;
        this.isWrongPassword = false;
        this.isSubscribed = true;
        this.getGroups();
      });
    } else {
      this.allGroups.subscribeToGroup(this.studyId, this.studyAccessType).subscribe(data => {
        if (data instanceof BasicError) {
          if (data instanceof Error409) {
            this.isPending = true;
          } else {
            this.isSubscribed = false;
          }
          return;
        }

        if (this.studyAccessType === 'invite') {
          this.isSubscribed = false;
          this.isInvite = true;
        } else {
          this.isSubscribed = true;
          this.getGroups();
        }
      });
    }

    this.showQuestionToSub = false;
  }

  public initModalWindow() {
    this.isInvite = false;
    this.isSubscribed = false;
    this.showQuestionToSub = true;
    this.isPassword = false;
    this.isUndefined = false;
    this.isWrongPassword = false;
    this.isPending = false;
  }


  public getGroups() {
    this.myArr = [];
    this.myObj = [];
    $('#datatable-responsive').dataTable().fnDestroy();
    this.allGroups.getAllGroups().subscribe(data => {
      if (this.tmpMyArr !== null) {
        $('#datatable-responsive').dataTable().fnDestroy();
        this.myArr = this.tmpMyArr;

        this.myObj = [];
        for (const group of data) {
          if (group instanceof Study && group.getId() === '1') {
            continue;
          }
          this.myObj.push(group);
        }

        this.tmpMyArr = null;
        this.tmpMyObj = null;
      } else {
        this.tmpMyObj = [];
        for (const group of data) {
          if (group instanceof Study && group.getId() === '1') {
            continue;
          }
          this.tmpMyObj.push(group);
        }
      }
    });

    this.allGroups.getMyGroups().subscribe(data => {
      for (const group of data) {
        if (group instanceof Study && group.getId() === '1') {
          continue;
        }
        this.myArr.push(group);
      }
      if (this.tmpMyObj !== null) {
        $('#datatable-responsive').dataTable().fnDestroy();
        this.myArr = [];
        for (const group of data) {
          if (group instanceof Study && group.getId() === '1') {
            continue;
          }
          this.myArr.push(group);
        }

        this.amountStudies = this.myArr.length;
        if (this.amountStudies >= 1) {
          this.canSubscribe = false;
        } else {
          this.canSubscribe = true;
        }
        this.myObj = this.tmpMyObj;
        this.tmpMyArr = null;
        this.tmpMyObj = null;
      } else {
        this.tmpMyArr = [];
        for (const group of data) {
          if (group instanceof Study && group.getId() === '1') {
            continue;
          }
          this.tmpMyArr.push(group);
        }
      }
    });
  }


  public unsubscribeFromGroup(stId: String, stTitle: String) {
    this.isUnsubscribed = false;

    this.studyTitle = stTitle;
    this.studyId = stId;
  }

  public finallyUnsubscribeFromGroup() {
    this.allGroups.unsubscribeFromGroup(this.studyId).subscribe(data => {
      if (data instanceof BasicError) {
        console.log(data);
      }
    });

    this.getGroups();
    this.isUnsubscribed = true;
  }

  public navigateToGroupDetailsPatient(stId: String) {
    this.groupdetailspatientUrl = 'groups/' + stId;

    this.naviService.navigateToUrl(this.groupdetailspatientUrl, 'groups');
  }

  /**
  * Navigate to follow string
  * @param name string to navigate to
  */
  public navigate(name: String): void {
    this.naviService.setCurrentPage(name);
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/group/group.component.ts